import { render, staticRenderFns } from "./PreferenceAddToBucket.vue?vue&type=template&id=6f1dfbcf&scoped=true&"
import script from "./PreferenceAddToBucket.vue?vue&type=script&lang=js&"
export * from "./PreferenceAddToBucket.vue?vue&type=script&lang=js&"
import style0 from "./PreferenceAddToBucket.vue?vue&type=style&index=0&id=6f1dfbcf&lang=scss&scoped=true&"
import style1 from "./PreferenceAddToBucket.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../nonspa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1dfbcf",
  null
  
)

component.options.__file = "PreferenceAddToBucket.vue"
export default component.exports